import { useCallback } from 'react';
import { useNavigate, type NavigateOptions, type To } from 'react-router-dom';
import { useNavigationLoader } from './useNavigationLoader';

export function useNavigateWithLoader() {
  const navigate = useNavigate();
  const { startNavigation } = useNavigationLoader();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      startNavigation();
      navigate(to, options);
    },
    [navigate, startNavigation]
  );
}
